import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getProductsByCategory } from "../../store/actions/product";
import {
  createCustomer,
  loginCustomer,
  logOut
} from "../../store/actions/customer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import Widget from "../../components/shared/Widget";
import AccountWidget from "../../components/shared/AccountWidget";
import FlashMessage from "../../components/shared/FlashMessage";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import { Link } from "react-router-dom";
import ProductItem from "../../components/ProductItem";
import Loading from "../../components/shared/Loading";

import styles from "../../thema/style";

class Account extends Component {
  render() {
    if (!this.props.customer.customer) {
      return (
        <Redirect
          to={{
            pathname: "/giris-yap"
            // state: { referrer: currentLocation }
          }}
        />
      );
    }
    return (
      <React.Fragment>
        <PageTitle title={"Hesabım"} />
        <div className="row">
          <div className={"container"}>
            <div className="row">
              <div className={"col-md-9"} style={{ marginTop: 15 }}>
                <h2>Hesabım</h2>
                <FlashMessage />
                <p>
                  Merhaba,{" "}
                  <strong>
                    {this.props.customer.customer &&
                      this.props.customer.customer.full_name}
                  </strong>!
                </p>
                <hr />
                <p>
                  <strong>"Hesabım"</strong> sayfasından siparişlerinizi takip
                  edebilir; üyelik bilgisi güncelleme, şifre ve adres
                  değişikliği gibi hesap ayarlarınızı kolayca yapabilirsiniz.
                </p>
                <hr />
                <ul className={styles.accountList}>
                  <li>
                    <Link to={"/hesabim/siparislerim"}>
                      <img src="/images/account/fast-delivery.png" />
                    </Link>
                    <div>
                      <Link to={"/hesabim/siparislerim"}>SİPARİŞLERİM</Link>
                    </div>
                  </li>
                  <li>
                    <Link to={"/hesabim/adreslerim"}>
                      <img src="/images/account/sign-post.png" />
                    </Link>
                    <div>
                      <Link to={"/hesabim/adreslerim"}>ADRESLERİM</Link>
                    </div>
                  </li>
                  <li>
                    <Link to={"/hesabim/profilimi-duzenle"}>
                      <img src="/images/account/user.png" />
                    </Link>
                    <div>
                      <Link to={"/hesabim/profilimi-duzenle"}>
                        PROFİLİMİ DÜZENLE
                      </Link>
                    </div>
                  </li>
                  <li>
                    <Link to={"/hesabim/sifremi-guncelle"}>
                      <img src="/images/account/password.png" />
                    </Link>
                    <div>
                      <Link to={"/hesabim/sifremi-guncelle"}>
                        ŞİFREMİ DEĞİŞTİR
                      </Link>
                    </div>
                  </li>
                  <li>
                    <Link to={"/hesabim/siparis-gecmisim"}>
                      <img src="/images/account/cash-back.png" />
                    </Link>
                    <div>
                      <Link to={"/hesabim/siparis-gecmisim"}>
                        SİPAİRŞ GEÇMİŞİM
                      </Link>
                    </div>
                  </li>
                  <li>
                    <Link
                      to={"/cikis-yap"}
                      onClick={e => {
                        e.preventDefault();
                        this.props.logOut();
                      }}
                    >
                      <img src="/images/account/exit.png" />
                    </Link>
                    <div>
                      <Link
                        to={"/cikis-yap"}
                        onClick={e => {
                          e.preventDefault();
                          this.props.logOut();
                        }}
                      >
                        ÇIKIŞ YAP
                      </Link>
                    </div>
                  </li>
                </ul>
              </div>
              <div className={"col-md-3"}>
                <AccountWidget />
                <CategoriesWidget />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ customer }) => {
  return { customer };
};

const mapDispatchToProps = { createCustomer, loginCustomer, logOut };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Account);



// WEBPACK FOOTER //
// ./src/routers/Account/index.js